import { CorsiView } from "@/pages/MensaMatricePage";

export default function ExtraCorsiPage() {
  return <CorsiView />;
}
